export const environment = {
    production: true,
    secret_key: '123456$#@$^@1ERF',
    environment_name:  'PROD',
    api_url:'https://ssoadmin.api.ces-ltd.com',
    agGridKey: 'Using_this_{AG_Grid}_Enterprise_key_{AG-049991}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Customized_Energy_Solutions}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{31_December_2024}____[v3]_[01]_MTczNTYwMzIwMDAwMA==bc50b3cd13b87faee5d20e79dd107aef',
    authMasterDb: 'Username-Password-Authentication',
    imagekitSDK:{
      publicKey: '',
      urlEndpoint: ''
    },
    auth:{
      custom_domain: 'identity-v2.ces-ltd.com',
      client_id: 'rhNerYHwgYrIYHw6XNhfhoBIPVcPUj3P',
      client_secret: 'NqVS5jFU0k1UzHeMmBtzFvQh7xrMSn_C0Ay__He376fDZxfkjXw4_1S3PsUNkEgh',
      audience: 'urn:auth0-sso-dashboard',
      auth_domain:'identity-ces-ltd.us.auth0.com',
    },
    s3Service: {
      client_id:  'E6i2iR7rUfflcYtNoPxhwM9Dy0gxefXaKulbJ8qI',
      client_secret:  '8Ac9qgP7iVtPpsg4x54lfl4rsTVopJ5RQxsnNCNsWKpml5CANUz8LFo7x4eHwRrxvDI4Bkop8d8GSvKeHAqP2GsDGyb7Q2KNaRcoJAPlFxeKqSzRJMeE8KuiP9Uattzx',
      s3_api_url:  'https://s3api.ces-ltd.com/',
      s3FileLocation:  'public',
      s3ConfigId:  '84',
    },
    dataDog: {
      applicationId:'02b249e7-d9b3-4fed-8c92-8a01ea3d3672',
      clientToken:'pubdbdf43f0da755d1f295a4afc7e8d5ffe',
      site:'datadoghq.com',
      service:'sso-dashboard',
      version:'1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
    },
    weatherApiKey:'23c4e6804701064678430b3703725689',
    app_name:'admin',
    intercom_id:'ui9nw23c',
    enterpriseConnectionName:'EnterpriseCESAD',
    mfaAppClientId:'WwJ2hw0XONlEwfuFCmJjodQlQM8EBV0U',
    mfaAppClientSecret:'X7o2C_MzUEboXFUeOcYAXqyIy3gCKsU0j0cR_ltwt5sAIo3d0Vs23wR9GFi0pu1X',
  };
